module.exports = __webpack_public_path__ + "img/bgr-confetti.062bc4bb.svg";